import { NavigationButton } from "@components/common/NavigationLink";
import { AddCircleOutline, FormatListBulleted } from "@mui/icons-material";
import { RoutePaths } from "@utils/constants/routes";
import { useTranslation } from "react-i18next";

import LinksSubHeader from "..";

function ClientSubHeader() {
  const { t } = useTranslation();

  return (
    <LinksSubHeader>
      <NavigationButton
        to={RoutePaths.adminOrganizationsTable}
        includes={[RoutePaths.organizationsTable, RoutePaths.adminOrganization]}
        icon={<FormatListBulleted />}
      >
        {t("layouts.sub-headers.organization.organization-list")}
      </NavigationButton>
      <NavigationButton
        to={RoutePaths.adminNewOrganization}
        includes={RoutePaths.newOrganization}
        icon={<AddCircleOutline />}
      >
        {t("layouts.sub-headers.organization.create-organization")}
      </NavigationButton>
    </LinksSubHeader>
  );
}

export default ClientSubHeader;
